export const secciones = {
  '1': 'NPS',
  '2': 'Statements',
  '3': 'Control questions',
  '4': 'Demographics',
  '5': 'Open questions',
  '6': '4All Practices',
  '7': 'Additional questions',
  '8': 'NOM035 Statements',
}
export const preguntas = {
  '1': 'Multiple option question (Radio button)',
  '2': 'Open question',
  '3': 'Statement',
  '4': 'Multiple option question (Radio button)',
  '5': '4All Practice',
  '6': 'Multiple option question (Check button)',
  '7': 'NOM035 Statement',
  '8': 'Audio',
}
export const abiertas = {
  '1': 'Open text',
  '2': 'Numeric text',
}

export const preguntasEspeciales = {
  '1': 'Normal question',
  '2': 'Special question',
}
